import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { COLORS } from '../../utils/colors';
import { MagnifyingGlassIcon } from '../../assets/icons/MagnifyingGlassIcon';
import { t } from 'i18next';

const RootDiv = styled.div`
  background: white;
  border: 0;
  box-shadow: 0 0 7px ${COLORS.gray_50};
  border-radius: 5px;
  display: flex;
  padding-block: 5px;
  padding-inline: 10px;
  gap: 10px;
  align-items: center;
`;

const Input = styled.input`
  flex: 1;
  color: ${COLORS.blue};
  border: 0;
  outline: none;
`;

interface TopLabelInputProps {
  id: string;
  value: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const SearchInput: React.FC<TopLabelInputProps> = ({ id, value, onChange }) => {
  return (
    <RootDiv>
      <Input type="text" id={id} placeholder={t('search')} value={value} onChange={onChange} />
      <MagnifyingGlassIcon width={16} height={16} color={COLORS.blue} />
    </RootDiv>
  );
};
